import { useEffect, useState } from 'react';

const features = [
  { id: 'drag-drop', name: 'Drag & Drop Builder', icon: 'ri-drag-drop-line' },
  { id: 'ios-android', name: 'iOS & Android', icon: 'ri-smartphone-line' },
  { id: 'live-preview', name: 'Live Preview', icon: 'ri-eye-line' },
  { id: 'publish', name: 'Publish Instantly', icon: 'ri-rocket-line' },
  { id: 'templates', name: '50+ Templates', icon: 'ri-layout-grid-line' },
  { id: 'integrations', name: 'API Integrations', icon: 'ri-plug-line' },
  { id: 'analytics', name: 'Analytics', icon: 'ri-bar-chart-line' },
  { id: 'support', name: '24/7 Support', icon: 'ri-customer-service-line' },
];

export default function FeaturesBar() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 py-6 border-y border-purple-500/20 shadow-lg">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center gap-3 overflow-x-auto pb-2 scrollbar-hide">
          {features.map((feature, index) => (
            <div
              key={feature.id}
              className={`flex items-center gap-2.5 px-6 py-3 rounded-lg whitespace-nowrap transition-all duration-500 bg-gray-800/50 text-gray-300 border border-purple-500/20 hover:border-purple-500/40 hover:bg-gray-700/70 hover:scale-105 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
              style={{ transitionDelay: `${index * 50}ms` }}
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${feature.icon} text-lg text-purple-400`}></i>
              </div>
              <span className="font-medium text-sm">{feature.name}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}